import type { DraftChoiceNotice } from './draftChoice';

/**
 * The draft wording helpers (`twin-launch-history-draft-choice`), shared by Versions, its
 * confirmations, the Twin Details banner and the hook's announcements so the same instant and the
 * same notice read the same everywhere.
 */

/** Date and time in the viewer's locale and zone, from a server ISO stamp. */
export const whenText = (iso: string | null | undefined): string => {
  if (!iso) return 'at an unknown time';
  const t = new Date(iso);
  return Number.isNaN(t.getTime())
    ? 'at an unknown time'
    : t.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
};

const NOTICE_TEXT: Record<DraftChoiceNotice, string> = {
  'production-unread':
    "Couldn't check what's live, so your draft is shown as saved. Reload to check again.",
  'launch-in-progress': 'A launch of this twin is in progress. Your draft is shown as saved.',
};

/** Why the draft is shown as saved — shown on Twin Details and announced. */
export const noticeText = (notice: DraftChoiceNotice): string => NOTICE_TEXT[notice];
